const singlePost = {
  init: function () {
    singlePost.events();
  },

  events: function () {
    if ($(".soc-share").length) {
      $("body").on("click", ".soc-share", function (e) {
        e.preventDefault();

        var platform = $(this).attr("data-platform");
        var data = $(this).attr("data-content");

        helpers.share(platform, data);
      });
    }
  },
};
export default singlePost;
